/* file update lmld 2025-05-25 */

import React, { useState } from 'react';

/* Styles */
import './App.css';

/* Utilities */
import {
  Route,
  Routes,
  Navigate // ✅ Se reemplaza Redirect por Navigate
} from 'react-router-dom';
import { useLocation } from 'react-router-dom'; // ✅ Corrección
import ScrollToTop from './utils/ScrollToTop';

/* Components */
import FilterDrawer from './components/FilterDrawer';
import Header from './layouts/Header';
import Footer from './layouts/Footer';

/* Modules */
// import Authors from './components/modules/Authors';
// import Groups from './components/modules/Groups';
// import Home from './components/modules/Home';
// import Institutions from './components/modules/Institutions';
// import Trends from './components/modules/Trends';
// import Compendium from './components/modules/Compendium';
// import Calls from './components/modules/Calls';
import NotFound from './components/modules/NotFound';
// import Policies from './components/modules/Policies';
// import Regulations from './components/modules/Regulations';
// import Techdocs from './components/modules/Techdocs';
// import SearchResult from './components/modules/SearchResult';
// import Subjects from './components/modules/Subjects';
// import UserManual from './components/modules/UserManual';
// import Metrics from './components/modules/Metrics';
import Convocatorias2025 from './components/modules/calls2025'; //new import, call module calls2025
import Proyectos2025 from './components/modules/projects2025'; //new import, call module calls2025
import Home_new from './components/modules/Homenew';


/* UI Library Components */
import { Layout, BackTop } from 'antd';

function App() {
  const location = useLocation();
  const [URL, setURL] = useState(location.pathname + location.search);
  const [filters, setFilters] = useState(null);
  const [home, setHome] = useState(false);
  const core = { URL, setURL, filters, setFilters, home, setHome };

  // Función para determinar si mostrar el FilterDrawer
  const shouldShowFilterDrawer = () => {
    const currentPath = location.pathname;
    // Solo mostrar filtros en páginas que realmente los necesiten
    const pagesWithFilters = [
      '/app/search',
      '/app/authors', 
      '/app/groups',
      '/app/institutions',
      '/app/subjects',
      '/app/compendium',
      '/app/calls',
      '/app/trends'
    ];
    return pagesWithFilters.includes(currentPath);
  };

  return (
    <>
      <ScrollToTop />
      <BackTop />
      {/* Solo renderizar FilterDrawer cuando sea necesario */}
      {shouldShowFilterDrawer() && <FilterDrawer core={core} />}
      <Layout>
        <Header core={core} />
        <Layout.Content id="content-box">
          <Routes>
            <Route path="/" element={<Navigate to="/app" replace />} />
            {/* <Route path="/app" element={<Home core={core} />} />  // Se comenta por actualización a HomeNuevo */}
            <Route path="/app" element={<Home_new core={core} />} />
            
            {/* Rutas activas - Solo las 3 que están en el menú */}
            <Route path="/app/calls2025" element={<Convocatorias2025 core={core} />} />
            <Route path="/app/projects2025" element={<Proyectos2025 core={core} />} />
            
            {/* Rutas deshabilitadas - Redirigen a la página principal */}
            <Route path="/app/search" element={<Navigate to="/app" replace />} />
            <Route path="/app/authors" element={<Navigate to="/app" replace />} />
            <Route path="/app/groups" element={<Navigate to="/app" replace />} />
            <Route path="/app/institutions" element={<Navigate to="/app" replace />} />
            <Route path="/app/subjects" element={<Navigate to="/app" replace />} />
            <Route path="/app/manual" element={<Navigate to="/app" replace />} />
            <Route path="/app/trends" element={<Navigate to="/app" replace />} />
            <Route path="/app/compendium" element={<Navigate to="/app" replace />} />
            <Route path="/app/calls" element={<Navigate to="/app" replace />} />
            <Route path="/app/regulations" element={<Navigate to="/app" replace />} />
            <Route path="/app/techdocs" element={<Navigate to="/app" replace />} />
            <Route path="/app/policies" element={<Navigate to="/app" replace />} />
            <Route path="/app/metrics" element={<Navigate to="/app" replace />} />
            
            <Route path="*" element={<NotFound core={core} />} />
          </Routes>
        </Layout.Content>
        <Footer core={core} />
      </Layout>
    </>
  );
}

export default App;
